/**
 * 是否保留路由
 * return true保留 false去除
 */
export const handleKeepRoute = (route, userRole) => {
  const role = (route.meta && route.meta.role) || []
  if (role.length === 0) {
    return true
  }
  // userRole: 1-租户 2-诊所代理人
  return role.indexOf(userRole) > -1
}

/**
 * 管理端路由(租户和操作者路由基本一致)
 * role
 * 0 租户管理员
 * 1 诊所代理人
 */
export const businessRoutes = [
  {
    name: 'Layout',
    path: '/layout/index',
    children: [
      // 首页
      {name: 'Home', path: '/home/index'},
      // 个人中心
      {
        name: 'TenantUserMine',
        path: '/business/mine/index'
      },
      // 采集记录
      {
        name: 'CollectRecord',
        path: '/collect-record/index'
      },
      // 档案管理
      {name: 'ArchivesManage', path: '/archives/manage/index'},
      {name: 'WorkBench', path: '/archives/workbench/index'},
      {
        name: 'WorkBench',
        path: '/archives/workbench/add',
        component: '/archives/workbench/index'
      },
      // 采集账号
      {
        name: 'SystemUser',
        path: '/system/user/index',
        meta: {superRole: [1]}
      },
      // 模板管理
      {
        name: 'Template',
        path: '/system/template/index',
        meta: {superRole: [1]}
      },
      {
        name: 'Analyse',
        path: '/system/analyse/index',
        meta: {superRole: [1]}
      },
      {
        name: 'TemplateManage',
        path: '/system/template/manage/index',
        meta: {superRole: [1]}
      },
      {
        name: 'TemplatePreview',
        path: '/system/template/preview/index',
        meta: {superRole: [1]}
      },
      {
        name: 'KnowedFileManage',
        meta: {superRole: [1]},
        path: '/system/file/index'
      },
      {
        name: 'SystemConfig',
        meta: {superRole: [1]},
        path: '/system/config/index'
      }
    ]
  }
]

/**
 * 平台管理员路由
 */
export const platformRoutes = [
  {
    name: 'Layout',
    path: '/layout/index',
    children: [
      // 首页
      {name: 'Home', path: '/platform/user/index'},
      // 基本信息
      {name: 'PlatformMine', path: '/platform/mine/index'},
      // 平台人员管理
      {name: 'PlatformUser', path: '/platform/user/index'},
      // 租户信息管理
      {name: 'PlatformTenant', path: '/platform/tenant/index'},
      // 操作日志
      {name: 'OperationLog', path: '/platform/log/index'},
      {
        name: 'Analyse',
        path: '/platform/analyse/index'
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js